import { FormLabel } from "@chakra-ui/react";
import React from "react";

const PrimaryFormLabel = (props) => {
  return <FormLabel fontWeight="bold" color="primary.1" {...props} />;
};

export default PrimaryFormLabel;
